/**
 *
 * @param {*} token
 */
function setToken(token) {
    if (typeof token === 'string' && token.length > 0) {
        localStorage.setItem('sb-token-master', token);
    }
}

/**
 *
 */
function getToken() {
    return localStorage.getItem('sb-token-master') || null;
}

/**
 *
 */
function removeToken() {
    localStorage.removeItem('sb-token-master');
}

/**
 *
 * @param {*} type
 */
function setUserType(type) {
    localStorage.setItem('sb-ut', type);
}

/**
 *
 */
function getUserType() {
    return localStorage.getItem('sb-ut') || null;
}

/**
 *
 */
function removeUserType() {
    localStorage.removeItem('sb-ut');
}

export {
    setToken,
    getToken,
    removeToken,
    setUserType,
    getUserType,
    removeUserType
};